import RestService from "./rest.service";

class scheduleService {
  list() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/schedules`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  get(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/schedule/` + id).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  stop(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/schedule/` + id + `/stop`,).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

}

export default new scheduleService();
